import React from "react";
import { LANGS, useI18n } from "@/i18n";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function LanguageSwitcher({ className = "" }) {
  const { lang, setLang } = useI18n();
  const { user, setUser } = useAuth();

  const change = async (code) => {
    setLang(code);
    if (user) {
      try {
        await api.post("/account/language", { language: code });
        setUser({ ...user, language: code });
      } catch {}
    }
  };

  return (
    <div className={`flex items-center gap-3 text-xs tracking-widest ${className}`} data-testid="language-switcher">
      {LANGS.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => change(l.code)}
          className={`transition-colors ${lang === l.code ? "text-gold" : "text-ink-muted hover:text-ink"}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
